import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useGetSystemSettingsQuery } from '@/store/api/systemApi';
import { useIsDemoUser, useIsMasterOwnerUser } from '@/hooks/redux';

interface FeatureRouteProps {
  feature: 'registration' | 'deposit' | 'withdrawal';
  children: ReactNode;
}

export function FeatureRoute({ feature, children }: FeatureRouteProps) {
  const isDemoUser = useIsDemoUser();
  const isMasterOwnerUser = useIsMasterOwnerUser();
  const { data: systemSettings, isLoading } = useGetSystemSettingsQuery(undefined, {
    pollingInterval: 30000,
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if ((feature === 'deposit' || feature === 'withdrawal') && isDemoUser) {
    return <Navigate to="/" replace />;
  }

  const bypassesSelection =
    (feature === 'deposit' || feature === 'withdrawal') && !isMasterOwnerUser;

  if (!bypassesSelection && !systemSettings?.[feature]?.selection) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
